import React from 'react';
import colors from '@th/shared/src/constants/colors';

export default function HorizontalLine({
  thickness = 1,
  color = colors.lightGray,
  className = 'my-4 md:my-6',
}) {
  return (
    <div
      className={className}
      style={{
        borderBottomColor: color,
        borderBottomWidth: thickness,
      }}
    />
  );
}
